<template>
  <v-dialog v-model="visible" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">フィルター</v-card-title>
      <v-card-text>
        <!-- プロパティを選択 -->
        <v-select v-model="filterPropertyId"  :items="combinedProperties.filter(item => !(item.propertyType === '8' && item.propertyName === 'コメント'))" item-title="propertyName"
          item-value="propertyId" label="プロパティを選択" clearable @change="logSelectedProperty" />

        <!-- プロパティの値を選択 -->
        <v-text-field v-if="selectedPropertyType === '1'" v-model="filterDataValue" label="プロパティの値を入力「数量」" type="number"
          clearable></v-text-field>

        <v-text-field v-if="selectedPropertyType === '2'" v-model="filterDataValue" label="プロパティの値を入力「少数」" type="number"
          clearable></v-text-field>

        <v-text-field v-if="selectedPropertyType === '3'" v-model="filterDataValue" label="プロパティの値を入力「日付」" type="date"
          clearable></v-text-field>

        <v-text-field v-if="selectedPropertyType === '4'" v-model="filterDataValue" label="プロパティの値を入力「時間」" type="time"
          clearable></v-text-field>

        <v-text-field v-if="selectedPropertyType === '5'" v-model="filterDataValue" label="プロパティの値を入力「テキスト」"
          clearable></v-text-field>

        <v-text-field v-if="selectedPropertyType === '6'" v-model="filterDataValue" label="プロパティの値を入力「ファイル名」"
          clearable></v-text-field>

        <v-select v-if="selectedPropertyType === '7'" v-model="filterDataValue" :items="currentPropertyValues"
          item-title="dataValue" item-value="selectionId" label="プロパティの値を選択" clearable no-data-text="先にプロパティを選択してください"
          @click="console.log('combinedProperties:', combinedProperties)" @change="logSelectedValue"></v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn color="blue" @click="applyFilter()">適用</v-btn>
        <v-btn color="green" @click="closeDialog">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from "@/eventBus";

export default {
  props: {
    value: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      selectedPropertyType: null,
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      combinedProperties: [],
      filterPropertyId: null,
      filterDataValue: null,
      filterCondition: [],
      selectValues: [],
      statusValues: [
        { value_id: 1, dataValue: "未着手" },
        { value_id: 2, dataValue: "完了" },
      ],
    };
  },
  mounted() {
    eventBus.on("clear", this.onClearEvent);
    console.log('value prop:', this.value);
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    currentPropertyValues() {
      const property = this.uniqueProperties.find(
        (item) => item.property.propertyId === this.filterPropertyId
      );

      if (property && Array.isArray(property.selectionItems)) {
        return property.selectionItems.filter(item => item.isDeleted === 0);
      }
      return [];
    },
  },
  watch: {
    filterPropertyId: {
      handler(propertyId) {
        if (propertyId) {
          const selectedProperty = this.combinedProperties.find((p) => p.propertyId === propertyId)
          this.selectedPropertyType = selectedProperty.propertyType
          this.filterDataValue = null;
        } else {
          console.log("propertyIdがnullです", propertyId)
          this.filterPropertyId = null;
          this.filterDataValue = null;
          this.selectedPropertyType = null;
        }
      },
    },
    data: {
      immediate: true,
      handler(newData) {
        if (!newData || !newData.data || !Array.isArray(newData.data) || newData.data.length === 0) {
          // console.error("無効なデータ構造です。'data'が見つかりません:", newData);
          this.uniqueProperties = [];
          this.combinedProperties = [];
          return;
        }
        this.uniqueProperties = this.getUniqueProperties(newData);
        this.combinedProperties = this.uniqueProperties.map((item) => ({
          propertyId: item.property.propertyId,
          propertyType: item.property.propertyType,
          propertyName: item.property.propertyName,
        }));
      },
    },
  },
  methods: {
    onClearEvent() {
      this.filterPropertyId = null;
      this.filterDataValue = null;
    },
    getUniqueProperties(response) {
      console.log("生データのレスポンス:", response);

      // Proxyデータから有効な構造を確認する
      const properties = response?.data?.[0]?.properties;
      if (!properties || !Array.isArray(properties)) {
        console.error(
          "無効なデータ構造です。'properties'が見つかりません:",
          response
        );
        return [];
      }
      console.log("抽出されたproperties配列:", properties);

      const seen = new Set();
      return properties.filter((item) => {
        // propertyNameが存在するか確認
        const propertyName = item.property?.propertyName;
        if (!propertyName) {
          console.warn("item内にpropertyNameがありません:", item);
          return false;
        }

        // 一意性を確認し、Setに追加
        const isUnique = !seen.has(propertyName);
        seen.add(propertyName);
        return isUnique;
      });
    },

    logSelectedProperty() {
      console.log("Selected Property ID:", this.filterPropertyId);
    },
    logSelectedValue() {
      console.log("Selected Value ID:", this.filterDataValue);
    },

    applyFilter() {
      try {
        const selectedProperty = this.uniqueProperties.find(
          (item) => item.property.propertyId === this.filterPropertyId
        );

        if (selectedProperty) {

          this.filterCondition = [
            {
              propertyId: selectedProperty.property.propertyId,
              propertyType: selectedProperty.property.propertyType,
              dataValue: this.filterDataValue
            },
          ];
        } else {
          this.filterCondition = [];
          alert("プロパティを選択してください");
          return;
        }
        if (!this.filterDataValue && selectedProperty.property.propertyName !== "コメント"){
          alert("プロパティの値を入力してください");
          return;
        }
        this.closeDialog();
        eventBus.emit("filter-updated");
        this.$emit("update:filterResult", this.filterCondition);

      } catch (error) {
        console.error(error.message);
      }
    },
    closeDialog() {
      this.visible = false;
      this.filterPropertyId = null;
      this.filterDataValue = null;
    },
  },
};
</script>

<style scoped>
/* 必要に応じてスタイルを調整 */
</style>
